import BaseService from "src/packages/BaseService";

export default class PackageService extends BaseService {
	static get className() {
		return "package";
	}
};
